(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_alpine-product-card-form"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('ProductForm', '@components/product-page');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_alpine-product-card-swym-wishlist"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('SwymWishlistButton', '@components/swym-wishlist');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_cart-drawer-recommended-products"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('RecommendedProducts', '@components/recommended-products');
  Alpine.asyncData('RecommendedProductsSearch', '@components/recommended-products');
  Alpine.asyncData('ProductForm', '@components/product-page');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_collection-filters"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('FilterBar', '@components/collection-filters');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_collection-pagination"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('Pagination', '@components/collection-filters');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_collection-product-grid"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('FilterableGrid', '@components/collection-filters');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_collection-sorting-list"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('SortBar', '@components/collection-filters');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_collection-sorting"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('SortBar', '@components/collection-filters');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_image-row-recommended-products-search"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('RecommendedProductsSearch', '@components/recommended-products');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_image-row-recommended-products"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('RecommendedProducts', '@components/recommended-products');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_luxe-summary"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('LuxeSummary', '@components/luxe-builder');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-atc"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('LockedATC', '@components/product-page');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-bundle-form"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('ProductForm', '@components/product-page');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-form-grid"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('ProductForm', '@components/product-page');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-form"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('ProductForm', '@components/product-page');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-gallery-thumbnails"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('ProductGalleryThumbnails', '@components/product-gallery');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-gallery"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('ProductGallery', '@components/product-gallery');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["all-blog-posts"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('AllBlogArticles', '@components/all-blog-articles');
  Alpine.asyncData('DynamicBlogArticle', '@components/all-blog-articles');
  Alpine.asyncData('BlogIndexPagination', '@components/all-blog-articles');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["inside-this-set"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('InsideThisSet', '@components/inside-this-set');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["marquee"] && !Shopify.designMode) return;
  try {
    window.Alpine.data('marquee', (speed) => ({
    init() {
      const strips = [...this.$el.querySelectorAll('.marquee')];
      const observer = new ResizeObserver(() => {
        // each copy translates by a percentage of its own width, so they only stay in
        // step while they measure the same -- hold off animating until they agree
        const widths = strips.map((el) => el.offsetWidth);
        if (!widths[0] || widths.some((width) => width !== widths[0])) return;
        this.$el.style.setProperty('--marquee-duration', widths[0] / speed + 's');
        strips.forEach((el) => el.classList.add('active'));
      });
      strips.forEach((el) => observer.observe(el));
    },
  }));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-wishlist-button"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('SwymWishlistButton', '@components/swym-wishlist');
  Alpine.asyncData('SwymWishlistPicker', '@components/swym-wishlist');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-recommendations"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('ProductRecommendations', '@components/product-recommendations');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["swym-wishlist-plp"] && !Shopify.designMode) return;
  try {
    Alpine.asyncData('SwymWishlistButton', '@components/swym-wishlist');
  } catch(e) { console.error(e); }
})();

})();
